import i18n from '@/utils/i18n';
import { formatCompactValue } from '@/experiences/sales-portal/domain/prospects/screens/prospects/blocs/utils/prospect-value-utils';
import { PROSPECT_STAGE_TRANSLATION_KEYS } from '@/experiences/sales-portal/domain/prospects/screens/prospects/constants';
import type {
  ManagerPipelineStageData,
  ManagerPipelineStageQueryRow,
} from '@/experiences/sales-portal/domain/prospects/screens/prospects/types';

const formatProspectCount = (count: number): string =>
  i18n.t(
    count === 1
      ? 'sales_portal.prospects.manager.pipeline.prospect_count'
      : 'sales_portal.prospects.manager.pipeline.prospect_count_plural',
    { count },
  );

export function transformToManagerPipelineStages(
  rows: ManagerPipelineStageQueryRow[],
): ManagerPipelineStageData[] {
  return rows.map((row) => ({
    prospectCount: row.prospect_count,
    prospectCountDisplay: String(row.prospect_count),
    prospectCountLabel: formatProspectCount(row.prospect_count),
    stage: row.stage,
    stageLabel: i18n.t(PROSPECT_STAGE_TRANSLATION_KEYS[row.stage]),
    totalValueDisplay: formatCompactValue(
      row.total_value_in_micros,
      row.currency_code,
    ),
    totalValueInMicros: row.total_value_in_micros,
  }));
}
